// extracted by mini-css-extract-plugin
export var bounce = "_on-1";
export var generatingText = "_on-6";
export var lightning = "_on-4";
export var popup = "_on-5";
export var progressBar = "_on-7";
export var progressFill = "_on-8";
export var progressShimmer = "_on-9";
export var progressText = "_on-a";
export var shimmer = "_on-3";
export var uploadIcon = "_on-0";
export var uploadingText = "_on-2";